import { call, put, select, take } from 'redux-saga/effects';
import { push } from '../../../lib/redux-router';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import ActionTypes from '../../../constants/ActionTypes';
import Paths from '../../../constants/Paths';

export function* goToRoot() {
  yield put(push(Paths.ROOT));
}

export function* goToProject(projectId) {
  yield put(push(Paths.PROJECTS.replace(':id', projectId)));
}

export function* goToBoard(boardId) {
  yield put(push(Paths.BOARDS.replace(':id', boardId)));
}

export function* goToCard(cardId) {
  yield put(push(Paths.CARDS.replace(':id', cardId)));
}

export function* handleLocationChange() {
  const pathsMatch = yield select(selectors.selectPathsMatch);

  if (!pathsMatch) {
    return;
  }

  switch (pathsMatch.pattern.path) {
    case Paths.LOGIN:
    case Paths.OIDC_CALLBACK:
      yield call(goToRoot);

      return;
    default:
  }

  const isInitializing = yield select(selectors.selectIsInitializing);

  if (isInitializing) {
    yield take(ActionTypes.CORE_INITIALIZE);
  }

  let board;
  let users;
  let projects;
  let boardMemberships;
  let labels;
  let lists;
  let cards;
  let cardMemberships;
  let cardLabels;
  let tasks;
  let attachments;
  let deletedNotifications;
  let cardPointData;
  let cardPointAdvancedData;
  let listReportData;
  let contentCardDefaults;

  switch (pathsMatch.pattern.path) {
    case Paths.BOARDS:
    case Paths.CARDS: {
      const currentBoard = yield select(selectors.selectCurrentBoard);

      if (currentBoard && currentBoard.isFetching === null) {
        yield put(actions.handleLocationChange.fetchBoard(currentBoard.id));

        try {
          ({
            item: board,
            included: {
              users,
              projects,
              boardMemberships,
              labels,
              lists,
              cards,
              cardMemberships,
              cardLabels,
              tasks,
              attachments,
              cardPointData,
              cardPointAdvancedData,
              listReportData,
              contentCardDefaults,
            },
          } = yield call(request, api.getBoard, currentBoard.id, true));
        } catch (error) {} // eslint-disable-line no-empty
      }

      if (pathsMatch.pattern.path === Paths.CARDS) {
        const notificationIds = yield select(selectors.selectNotificationIdsForCurrentCard);

        if (notificationIds && notificationIds.length > 0) {
          try {
            ({ items: deletedNotifications } = yield call(
              request,
              api.updateNotifications,
              notificationIds,
              {
                isRead: true,
              },
            ));
          } catch (error) {} // eslint-disable-line no-empty
        }
      }

      break;
    }
    default:
  }

  yield put(
    actions.handleLocationChange(
      board,
      users,
      projects,
      boardMemberships,
      labels,
      lists,
      cards,
      cardMemberships,
      cardLabels,
      tasks,
      attachments,
      deletedNotifications,
      cardPointData || [],
    ),
  );

  // Обрабатываем cardPointData для детекции закрытости задач
  if (cardPointData && cardPointData.length > 0) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (pointSystem) {
      for (const item of cardPointData) {
        if (item) {
          yield put(actions.fetchCardPointData.success(item.cardId, pointSystem.id, item));
        }
      }
    }
  }

  // Обрабатываем cardPointAdvancedData для подсчета суммы баллов
  if (cardPointAdvancedData && cardPointAdvancedData.length > 0) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (pointSystem) {
      // Группируем по cardId для обработки
      const cardPointAdvancedDataByCardId = {};
      cardPointAdvancedData.forEach((item) => {
        if (!cardPointAdvancedDataByCardId[item.cardId]) {
          cardPointAdvancedDataByCardId[item.cardId] = [];
        }
        cardPointAdvancedDataByCardId[item.cardId].push(item);
      });

      // Обрабатываем каждую карточку
      for (const cardId of Object.keys(cardPointAdvancedDataByCardId)) {
        const items = cardPointAdvancedDataByCardId[cardId];
        yield put(actions.fetchCardPointAdvancedData.success(cardId, pointSystem.id, items));
      }
    }
  }

  // Обрабатываем listReportData для отображения статуса закрытия месяца
  if (listReportData && listReportData.length > 0) {
    for (const item of listReportData) {
      if (item) {
        yield put(actions.fetchListReportData.success(item.listId, item));
      }
    }
  }

  // Обрабатываем contentCardDefaults для подсчета суммы баллов
  if (contentCardDefaults && contentCardDefaults.length > 0) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (pointSystem) {
      yield put(actions.fetchContentCardDefaults.success(pointSystem.id, contentCardDefaults));
    }
  }
}

export default {
  goToRoot,
  goToProject,
  goToBoard,
  goToCard,
  handleLocationChange,
};
